/**
 * @author Haekal <haekal@goapp.co.id>
 */

import React, { useMemo } from 'react'
import { Avatar, makeStyles } from '@material-ui/core'
import { AccountCircle } from '@material-ui/icons'
import { stringToColor } from 'shared/utils/stringToColor'

const sizeMap = {
  xxs: 15,
  xs1: 18,
  xs: 20,
  s1: 22,
  s: 24,
  m: 32,
  l: 40,
  xl: 48,
}

const useStyles = makeStyles(() => ({
  avatar: ({ size, backgroundColor }) => ({
    width: size,
    height: size,
    fontSize: size * 0.45,
    backgroundColor,
    color: '#fff',
    // fontWeight: 600,
  }),
}))

function AvatarInitialComponent({ user, size = 's', withBorder, iconColor = '#888' }) {
  let initials =
    user?.first_name && user?.last_name
      ? `${user?.first_name[0]}${user?.last_name[0]}`
      : (user?.first_name || user?.last_name || '?')[0]

  const fullName =
    user?.first_name && user?.last_name
      ? `${user?.first_name}${user?.last_name}`
      : (user?.first_name || user?.last_name || '?')

  if (user?.first_name === 'Contact') {
    initials = 'C'
  }

  const pixelSize = sizeMap[size] || sizeMap.s

  const bgColor = useMemo(() => {
    return user?.uid ? stringToColor(fullName) : 'transparent'
  }, [user?.uid])

  const classes = useStyles({ size: pixelSize, backgroundColor: bgColor })

  return (
    <Avatar className={classes.avatar} style={{ border: withBorder ? '1px solid #fff' : 'none' }}>
      {initials === '?' ? <AccountCircle htmlColor={iconColor} style={{ fontSize: pixelSize }} /> : initials.toUpperCase()}
    </Avatar>
  )
}

export const AvatarInitial = React.memo(AvatarInitialComponent)
